export const DiscountTypes = {
  IDiscountService: Symbol("IDiscountService"),
};
